var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { storeToRefs } from "pinia";
import { computed, unref } from "vue";
import { deletePage } from "@/api/pages";
import { useUserStore } from "@/stores/userStore";
export default /*#__PURE__*/ _defineComponent({
    __name: 'PageDropdown',
    props: {
        page: null,
        published: null
    },
    emits: ["onRemove", "onSuccess", "onError"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faCaretDown);
        const { isAnonymous } = storeToRefs(useUserStore());
        const readOnly = computed(() => props.page.shared || props.published || unref(isAnonymous));
        function onDelete(pageId) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    yield deletePage(pageId);
                    emit("onRemove", pageId);
                    emit("onSuccess");
                }
                catch (error) {
                    emit("onError", error);
                }
            });
        }
        return { __sfc: true, props, isAnonymous, emit, readOnly, onDelete, FontAwesomeIcon };
    }
});
